import { useMemo } from "react";
import { useGetIdentity, useGetList } from "ra-core";

import { Task } from "../tasks/Task";
import { isDone, isRecentlyDone } from "../tasks/tasksPredicate";

export const CampaignMyTasks = ({ campaignId }: { campaignId: number | string }) => {
  const { identity } = useGetIdentity();
  const { data: tasks, isPending } = useGetList("tasks", {
    pagination: { page: 1, perPage: 500 },
    sort: { field: "due_date", order: "ASC" },
    filter: {
      sales_id: identity?.id,
      campaign_id: campaignId,
    },
  }, { enabled: !!identity });

  const visible = useMemo(
    () => tasks?.filter((t) => !isDone(t) || isRecentlyDone(t)) ?? [],
    [tasks],
  );

  if (isPending) return null;
  if (visible.length === 0) {
    return <p className="text-sm text-muted-foreground">No campaign tasks assigned to you.</p>;
  }

  return (
    <div className="flex flex-col gap-3">
      {visible.map((task) => (
        <Task key={task.id} task={task} showContact />
      ))}
    </div>
  );
};
